import styled from 'styled-components';
import { MQUERY } from 'common/constants';
import LikeIcon from 'svg-files/icons/like.svg';

export const VideoPlayerWidget = styled.div`
    ${ props => ( !props.inline && 'height: 40rem;' ) }
    position: ${ props => ( props.inline ? 'absolute' : 'relative' ) };
    ${ props => ( props.inline && 'inset: 0 1.2rem auto;' ) }
    ${ props => ( props.inline && 'border-radius: 12px;' ) }
    ${ props => ( props.inline && 'overflow: hidden;' ) }
    ${ props => ( props.inline && 'pointer-events: none;' ) }
    transition: opacity .5s ease-in-out .5s;

    &.is-hidden {
        opacity: 0;
        transition: opacity .5s ease-in-out;
    }
    
    video-js {
        width: 100%;
        height: ${ props => ( props.inline ? 'auto !important' : '40rem' ) };
        inset: 0;
        position: absolute;

        .vjs-big-play-button {
            display: none;
        }

        &::after {
            content: '';
            display: block;
            background: var(--bannerGradient);
            position: absolute;
            inset: 0;
            transition: opacity .5s ease-in-out;
        }

        &.vjs-playing {

            &::after {
                opacity: 0;
                pointer-events: none;
            }
        }

        .vjs-control-bar {
            background-color: #141D38;
        }
    }

    .video-js.vjs-layout-small .vjs-playback-rate,
    .video-js.vjs-layout-small .vjs-quality-menu-wrapper {
        display: block !important;
    }

    .vjs-pip-container {
        width: 100% !important;

        video-js {

            &.vjs-playing {

                &::after {
                    opacity: 0;
                    pointer-events: none;
                }
            }
        }
    }

    .vjs-poster {
        background-size: cover;

        img { 
            object-fit: cover;
        }
    }

    .vjs-container {
        width: 100% !important;
        height: auto;
        padding-bottom: 56.5%;
        position: relative;
    }

    video-js.vjs-pip-active {
        display: ${ props => ( props.ended ? 'none' : 'block' ) };
        height: 28rem !important;
        width: 100%;
        
        @media ${ MQUERY.TABLET } {
            width: 50rem;
        }
    }

    .video-js.vjs-pip-y-bottom {
        bottom: 0;
        
        @media ${ MQUERY.TABLET } {
            //the default value
            bottom: 1em;
        }
    }

    .video-js.vjs-pip-x-right {
        right: 0;
        
        @media ${ MQUERY.TABLET } {
            //the default value
            right: 1em;
        }
    }

    .video-js .vjs-tech {
        border-radius: 12px;
        overflow: hidden;
    }

    @media ${ MQUERY.TABLET } {
        ${ props => ( !props.inline && 'height: 46rem;' ) }

        video-js {
            height: 46rem;
        }
    }

    @media ${ MQUERY.DESKTOP_SMALL } {
        height: ${ props => ( props.inline ? '100%' : '70rem' ) }!important;

        video-js {
            height: ${ props => ( props.inline ? '100%' : '70rem' ) }!important;
        }

        .vjs-container {
            height: 100%;
            padding-bottom: 0;
        }
    }
`;

export const ImageContainer = styled.div`
    ${ ( { isPlaying } ) => isPlaying && 'opacity: 0' };
    ${ ( { isPlaying } ) => isPlaying && 'pointer-events: none' };
    background: rgba(0, 0, 0, .4);
    inset: 0;
    position: absolute;
    transition: opacity .5s ease-in-out;
    z-index: 10;
    &::after {
        content: '';
        display: block;
        background: var(--bannerGradient);
        pointer-events: none;
        position: absolute;
        inset: 0;
        transition: opacity .5s ease-in-out;
    }
`;

export const TitleAndPlayButtonWrapper = styled.div`
    ${ ( { isPlaying } ) => isPlaying && 'opacity: 0' };
    ${ ( { isPlaying } ) => isPlaying && 'pointer-events: none' };
    transition: opacity .5s ease-in-out;
    position: absolute;
    bottom: 0;
    left: 1.2rem;
    z-index: 10;

    @media ${ MQUERY.DESKTOP_SMALL } {
        position: relative;
        bottom: initial;
        left: initial;
    }
`;

export const InfoContainer = styled.div`
    position: relative;
    z-index: 10;

    &::after {
        border-bottom: 1px solid var(--neutral600);
        content: '';
        position: absolute;
        inset: auto var(--widget-padding-mobile) 0;
    }

    @media ${ MQUERY.DESKTOP_SMALL } {
        max-width: var(--widget-width);
        margin: 0 auto;
        transition: opacity .5s ease-in-out;

        &::after {
            display: none;
        }

        &.is-active {
            pointer-events: none;
            opacity: 0;
            transition: opacity .5s ease-in-out;
        }
    }
`;

export const InfoWrapper = styled.div`
    padding: 1.2rem var(--widget-padding-mobile) 2.4rem;
    position: relative;
    
    @media ${ MQUERY.DESKTOP_SMALL } {
        position: absolute;
        bottom: 0;
        padding: 2.4rem var(--widget-padding-desktop);
    }

`;

export const SeriesTitle = styled.h3`
    color: var(--white);
    margin-top: 0;
`;

export const Description = styled.p`
    color: var(--text);
    display: -webkit-box;
    margin-top: 1.6rem;
    line-height: 1.5;
    font-weight: var(--light);

    @media ${ MQUERY.DESKTOP_SMALL } {
        color: var(--white);
        max-width: 78rem;
    }
`;

export const MetaDataItem = styled.div`
    color: ${ props => ( !props.accessibilityDarkMode ? 'var(--neutral900light)' : props.theme === 'dark' ? 'var(--neutral300)' : 'var(--white)' ) };

    &::before {
        content: '';
        display: inline-block;
        margin: 0 1.2rem;
        width: 0.4rem;
        height: 0.4rem;
        background-color: var(--neutral300);
        border-radius: 100%;
    }
`;

export const UserInteractions = styled.div`
    text-decoration: ${ props => ( props.$enhance ? 'underline' : 'none' ) };
    margin-top: 2.4rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @media ${ MQUERY.DESKTOP_SMALL } {
        text-decoration-color: var(--lightText);
    }
`;

export const InteractionCta = styled.div`
    color: var(--socialButton);
    cursor: pointer;
    position: relative;
    display: inline-flex;
    align-items: center;
    transition: color 0.25s ease;
    user-select: none;

    &:hover {
        color: var(--button);
    }

    &:first-child {
        margin-right: 2.4rem;
    }

    @media ${ MQUERY.DESKTOP_SMALL } {
        color: var(--white);
    }
`;

export const InteractionButton = styled.div`
    display: flex;
    margin-right: 0.8rem;
    width: 3.2rem;
    height: 3.2rem;
    align-items: center;
    justify-content: center;
    border: 2px solid currentcolor;
    border-radius: 100%;
    transition: border-color 0.25s ease;
    ${({ liked }) => (liked === 'true' ? 'border-color: var(--button);' : '')}

    ${ InteractionCta }:hover & {
        border-color: var(--button);
    }
`;

export const Title = styled.h3`
    margin: 0 0 1.6rem;
`;

export const Like = styled(LikeIcon)`
    fill: var(--socialButton);
    transition: fill 0.25s ease;
    ${ ( { liked } ) => ( liked === 'true' ? 'fill: var(--button);' : '' ) }
    ${ ( { likeclicked } ) => ( likeclicked === 'true' ? 'animation: like-anim .5s ease-in-out;' : '' ) }
    
    ${ InteractionCta }:hover & {
        fill: var(--button);
    }

    @keyframes thumb-bump {
        0%,
        100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-0.3rem);
        }
    }

    @keyframes like-anim {
        0%,
        100% {
            transform: scale(1);
        }
        50% {
            transform: scale(3);
        }
    }
`;